import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
    Button,
    Row,
    Col
} from "reactstrap";
import Spinner from 'react-bootstrap/Spinner';
import SupplierService from "src/modules/3rd-party-management/apis/common/SupplierService";
import { RiPlug2Line } from "react-icons/ri";

const TraceApiSettings = ({
    t,
    setActiveAccordion,
    activeAccordion,
    supplierInfos
}) => {
    const {
        mutate: updateSettings,
        isLoading: updateSettingsInProgress
    } = useMutation({
        mutationFn: async (payload) => {
            const service = SupplierService.getInstance();
            return await service.updateTraceApiSettings(supplierInfos?.id, payload);
        },
        onSuccess: () => {
            toast(t("Trace API settings have been updated successfully."), {
                type: "success"
            });
        },
        onError: () => {
            toast(t("Failed to update Trace API settings. Please try again."), {
                type: "error"
            });
        }
    });

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('trace-api-settings')}
            className={activeAccordion === 'trace-api-settings' ? 'active' : ''}
            eventKey={'trace-api-settings'}
        >
            <Accordion.Header>
                <RiPlug2Line size={24} style={{ marginRight: '12px' }}/>
                <span>
                    {t('Trace API Settings')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <AvForm onValidSubmit={(_e, values) => {
                    updateSettings(values);
                }} className="needs-validation">
                    
                    <Row>
                        <Col sm='12' md="6" className="mb-3">
                            <AvField
                                name="supplierType"
                                type="select"
                                errorMessage={t("This field cannot be blank")}
                                className="form-control"
                                validate={{
                                    required: { value: true }
                                }}
                                id="supplier-type"
                                label={t('Supplier Type')}
                                defaultValue={supplierInfos?.supplierType || 'operator'}
                            >
                                <option value="operator">
                                    {t('Operator')}
                                </option>
                                <option value="trader">
                                    {t('Trader')}
                                </option>
                            </AvField>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm='12' md="6" className="mb-3">
                            <AvField
                                name="apiKey"
                                type="text"
                                errorMessage={t("This field cannot be blank")}
                                className="form-control"
                                validate={{
                                    required: { value: true }
                                }}
                                id="api-key"
                                label={t("API Key")}
                                defaultValue={supplierInfos?.apiKey}
                            />
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end align-items-center">
                        <Button 
                            color="primary" 
                            type="submit" 
                            disabled={updateSettingsInProgress}
                        >
                            {updateSettingsInProgress ? (
                                <>
                                    <Spinner 
                                        className="me-2" 
                                        variant="white" 
                                        size="sm"
                                    />
                                    {t('Updating')}...
                                </>
                            ) : (
                                t('Update')
                            )}
                        </Button>
                    </div>
                </AvForm>
            </Accordion.Body>
        </Accordion.Item>
    )
};

export default withNamespaces()(TraceApiSettings);